import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import {
  Button,
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Pagination,
  CircularProgress,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../styles/tableContent.style";
import moment from "moment";
import { getAdminRequestsThunk, createRequestThunk } from "./redux/documentRequestsSlice";
import RequestDocumentModal from "./components/RequestDocumentModal";

const AdminDocumentRequests = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { adminRequests, loading } = useSelector((state) => state.documentRequests);

  const fetchRequestsList = () => {
    dispatch(getAdminRequestsThunk());
  };

  useEffect(() => {
    fetchRequestsList();
    // eslint-disable-next-line
  }, []);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleRequestSubmit = (payload) => {
    dispatch(createRequestThunk(payload)).then((res) => {
      if (res?.payload?.success) {
        handleCloseModal();
        fetchRequestsList();
      }
    });
  };

  // Helper to calculate status summary
  const getStatusSummary = (vendorRequests) => {
    if (!vendorRequests || vendorRequests.length === 0) return "No Vendors";
    const counts = { PENDING: 0, UPLOADED: 0, APPROVED: 0, REJECTED: 0 };
    vendorRequests.forEach((vr) => {
      if (counts[vr.status] !== undefined) {
        counts[vr.status]++;
      }
    });

    const parts = [];
    if (counts.APPROVED > 0) parts.push(`${counts.APPROVED} Approved`);
    if (counts.UPLOADED > 0) parts.push(`${counts.UPLOADED} Pending Review`);
    if (counts.REJECTED > 0) parts.push(`${counts.REJECTED} Rejected`);
    if (counts.PENDING > 0) parts.push(`${counts.PENDING} Pending Upload`);

    return `${parts.join(", ")} (Total: ${vendorRequests.length})`;
  };

  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Requested Documents
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "end",
              gap: "0.5rem",
            }}
          >
            <Button variant="contained" size="large" onClick={handleOpenModal}>
              + Request Document
            </Button>
          </Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        {loading && adminRequests.length === 0 ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
            <CircularProgress />
          </div>
        ) : (
          <CustomTableContainer component={Card}>
            <Table aria-label="simple table">
              <CustomTableHead>
                <TableRow>
                  <TableCell>
                    <TableHeaderFont>Sr. No.</TableHeaderFont>
                  </TableCell>
                  <TableCell>
                    <TableHeaderFont>Document Name</TableHeaderFont>
                  </TableCell>
                  <TableCell>
                    <TableHeaderFont>Requested By</TableHeaderFont>
                  </TableCell>
                  <TableCell>
                    <TableHeaderFont>Due Date</TableHeaderFont>
                  </TableCell>
                  <TableCell>
                    <TableHeaderFont>Submission Status</TableHeaderFont>
                  </TableCell>
                  <TableCell align="center">
                    <TableHeaderFont>Actions</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </CustomTableHead>

              <TableBody>
                {adminRequests && adminRequests.length > 0 ? (
                  adminRequests.map((item, index) => (
                    <TableRow
                      key={item.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ fontWeight: 500 }}>{item.document_name}</TableCell>
                      <TableCell>
                        {item.Requester
                          ? `${item.Requester.first_name} ${item.Requester.last_name}`
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item.due_date ? moment(item.due_date).format("DD MMM YYYY") : "No Limit"}
                      </TableCell>
                      <TableCell>{getStatusSummary(item.VendorRequests)}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => navigate(`/app/document-requests/${item.id}`)}
                        >
                          View Submissions
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center" style={{ padding: "2rem" }}>
                      No requested documents found. Click "+ Request Document" to create one.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
        )}
      </StepperContentHolder>

      <RequestDocumentModal
        open={modalOpen}
        handleClose={handleCloseModal}
        onSubmit={handleRequestSubmit}
      />
    </div>
  );
};

export default AdminDocumentRequests;
